import * as React from "react";
import Table from "../../../components/Table/Table";
import { Dimmer } from "semantic-ui-react";
import { editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";
import EditMonitoringFaultCategory from "../../Editing/EditMonitoringFaultCategory";

/**
 * All the following props are passed from parent component
 */
export type MonitoringFaultCategoriesTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  isLoadingFaultCategories: boolean;
  editActions: typeof editActions;
  pdApiActions: typeof pdApiActions;
  mainActions: typeof mainActions;
  subMenuRoute: State.MonitoringSubmenu;
  toggleModal: () => void;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.MonitoringSubmenu, columnFilter: Filter[]) => void;
};

export const MonitoringFaultCategoriesTable: React.FC<MonitoringFaultCategoriesTableProps> = (
  props
) => {
  const {
    columns,
    pdApi,
    mainState,
    isEditActive,
    isLoadingFaultCategories,
    editActions: editActionsDispatched,
    mainActions: mainActionsDispatched,
    toggleModal,
    setColumnFilters,
    subMenuRoute
  } = props;

  const { editSize, pageSize, isShortenTextEnabled } = mainState;

  const monitoringFaultCategoryRows: Api.FaultCategory[] = pdApi.monitoringFaultCategories
    ? _.values(pdApi.monitoringFaultCategories)
    : [];
  const selectedColumns: State.Column[] = columns["Monitoring Fault Categories" as keyof State.ColumnMap];

  const startingPage = mainState.lastEditedObjectId
    ? (monitoringFaultCategoryRows.findIndex(
        faultCategory => faultCategory.id === mainState.lastEditedObjectId
      ) / mainState.pageSize) >>
      0
    : 0;

  const handleFilterChangeDebounced = React.useMemo(
    () => _.debounce((changedFilters: Filter[]) => {
      setColumnFilters(subMenuRoute, changedFilters);
    }, 500),
    [setColumnFilters, subMenuRoute]
  );

  React.useEffect(() => () => {
    mainActionsDispatched.setLastEditedObjectId(undefined);
  }, [mainActionsDispatched]);

  const isRowSelected = (faultCategory: Api.FaultCategory): boolean => {
    const { editedObjectId } = props;
    return editedObjectId ? editedObjectId === faultCategory.id : false;
  };

  return (
    <div className="flex-1">
      <div className="flex-1">
        <Table
          startingPage={startingPage}
          rows={monitoringFaultCategoryRows}
          loading={isLoadingFaultCategories}
          loadingText="Fetching monitoring fault categories..."
          columns={selectedColumns}
          isHidingTextActive={isShortenTextEnabled}
          handleRowSelection={editActionsDispatched.select}
          isRowSelected={isRowSelected}
          pageSize={pageSize}
          handleFilterChange={handleFilterChangeDebounced}
        />
      </div>
      {isEditActive && (
        <Dimmer active={true} page={true}>
          <div
            className="edit-view"
            style={{ flex: editSize, width: editSize === 0.3 ? "500px" : "1000px" }}
          >
            <EditMonitoringFaultCategory toggleModal={toggleModal} />
          </div>
        </Dimmer>
      )}
    </div>
  );
};

export default MonitoringFaultCategoriesTable;
